import { render, staticRenderFns } from "./TheResetPasswordView.vue?vue&type=template&id=0456e043"
import script from "./TheResetPasswordView.vue?vue&type=script&lang=js"
export * from "./TheResetPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports